// popularne narzędzia, nieużywane wykomentowane
define(['jquery', 'app/global', 'jquery.cookie'], function ($, global) {

  var tools = {

    ajaxOverflow: {
      disable: function ($container) {
        if ($container && $container.length) {
          $container.find('> .ajax-overflow').remove();
        } else {
          $('.ajax-overflow').remove(); // remove all
        }
      },
      enable: function ($container, _class) {
        _class = (!_class) ? '' : ' ' + _class;
        $container.append('<div class="ajax-overflow' + _class + '"></div>');
      }
    },
    // microtime: function() {
    //     return (new Date()).getTime(); // or +( new Date() ) or $.now()
    // },
    uniqueID: (function () {
      var _now = (new Date()).getTime();
      return function () {
        return (_now++).toString(36);
      };
    }()),
    isTablet: function () {
      return global.cache.$body.width() < 930;
    },
    // isNumber: function(n) {
    //     return !isNaN(parseFloat(n)) && isFinite(n);
    // },
    substitute: function (str, sub, allowEmpty) {
      return str.replace(/{(.+?)}/g, function (match, name) {
        if (name in sub && String(sub[name]).length) {
          return sub[name];
        } else {
          return (allowEmpty) ? '' : '&#8212;';
        }
      });
    },
    isLocalLink: function (link) {
      return link.indexOf('http') === -1 || link.indexOf(location.host) > -1;
    },
    canvasSupport: function () {
      var canvas = document.createElement('canvas');
      return !!(canvas.getContext && canvas.getContext('2d'));
    },
    debounce: function (fn, delay) {
      var timer = null;
      return function () {
        var context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    },
    getTemplate: function (name) {
      var template;
      if (!global.templates) {
        global.templates = {};
      }
      if (!global.templates[name]) {
        template = $('#template-' + name);
        if (template.length) {
          template = template.html();
          global.templates[name] = template;
          //console.info(1, global.templates);
          return template;
        }
      } else {
        //console.info(2, global.templates);
        return global.templates[name];
      }
    },
    ajax: function (params) {
      var settings = $.extend({
          url: '',
          abort: false,
          ajaxName: false,
          data: '',
          type: 'get',
          dataType: 'html',
          cache: false,
          beforeCallback: $.noop,
          afterCallback: $.noop,
          successCallback: $.noop,
          failCallback: $.noop,
          noConnectionCallback: $.noop,
          normalErrorCallback: $.noop
        }, params),
        ajax;
      if (settings.abort && settings.ajaxName && global.ajax[settings.ajaxName]) {
        global.ajax[settings.ajaxName].abort();
      }
      settings.beforeCallback();
      ajax = $.ajax({
          url: settings.url,
          data: settings.data,
          type: settings.type,
          dataType: settings.dataType,
          cache: settings.cache
        })
        .done(function (response) {
          settings.successCallback(response);
        })
        .fail(function (jqXhr) {
          settings.failCallback(jqXhr);
          console.log('ajax failed', jqXhr, jqXhr.status, jqXhr.statusText);
          if (jqXhr.statusText !== 'abort') {
            if (jqXhr.status === 0 || jqXhr.status === 12007 || jqXhr.status === 12019) {
              settings.noConnectionCallback(jqXhr);
            } else {
              settings.normalErrorCallback(jqXhr);
            }
          }
        }).always(function () {
          if (settings.abort && settings.ajaxName) {
            global.ajax[settings.ajaxName] = false;
          }
          settings.afterCallback();
        });
      if (settings.abort && settings.ajaxName) {
        global.ajax[settings.ajaxName] = ajax;
      }
    },
    randomString: function () {
      var text = '',
        possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 64; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    csrfToken: function (form) {
      var $this = $(form),
        csrftoken = $.cookie('csrftoken'),
        input = $this.find('input[name=csrfmiddlewaretoken]');
      if (typeof csrftoken !== 'string' || typeof csrftoken === 'string' && csrftoken.length !== 64) {
        csrftoken = tools.randomString();
        $.cookie('csrftoken', csrftoken, {
          expires: 3,
          path: '/'
        });
      }
      if (!input.length) {
        $this.append('<input type="hidden" name="csrfmiddlewaretoken" value=' + csrftoken + '>');
      } else {
        input.val(csrftoken);
      }
    }

  };

  return tools;

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/tools.js